import { StyleSheet, View } from "react-native";
import { Text } from "react-native-paper";

import { colors, fonts } from "@/lib/theme";

interface Props {
    /** Display label, e.g. "Chart", "Answers", "Narrative". */
    label: string;
    /**
     * Optional count or short string shown after a dot separator.
     * Omit (or pass null/empty) to render the label only.
     */
    count?: string | number | null;
}

/**
 * Small teal-tinted chip used inside the Diagnoses chapter idle state.
 * Labels-only mode is the default surface ("Chart", "Answers", "Narrative");
 * pass `count` to render "Chart · 12" style with a bolder ink count.
 */
export function SourceChip({ label, count }: Props) {
    const showCount = count != null && count !== "";
    return (
        <View style={styles.chip}>
            <View style={styles.dot} />
            {showCount ? (
                <Text style={styles.label}>
                    {label} · <Text style={styles.count}>{count}</Text>
                </Text>
            ) : (
                <Text style={styles.label}>{label}</Text>
            )}
        </View>
    );
}

const styles = StyleSheet.create({
    chip: {
        flexDirection: "row",
        alignItems: "center",
        gap: 5,
        paddingVertical: 5,
        paddingHorizontal: 10,
        borderRadius: 999,
        backgroundColor: "rgba(69,210,176,0.10)",
        borderWidth: 1,
        borderColor: "rgba(69,210,176,0.25)"
    },
    dot: {
        width: 4,
        height: 4,
        borderRadius: 2,
        backgroundColor: colors.teal400
    },
    label: {
        fontFamily: fonts.bold,
        fontSize: 11,
        color: colors.teal600,
        letterSpacing: 0.2
    },
    count: {
        fontFamily: fonts.extraBold,
        color: colors.ink
    }
});
